/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import moment from 'moment';
import '../../css/pages/customers.css';
import undrawSearch from '../../assets/svgs/undraw_search_re_ttoj.svg';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import { fetchLoanRequests } from '../actions/p2p';
import Pagination from '../components/Pagination';
// import MoreIcon from '';
import LoanDetails from '../components/modals/LoanDetails';
import CreateLoan from '../components/modals/CreateLoan';
import EditLoan from '../components/modals/EditLoan';
import CancelLoan from '../components/modals/CancelLoan';
import AcceptLoan from '../components/modals/AcceptLoan';
import CreateLoanMultiple from '../components/modals/CreateLoanMultiple';
import CreateLoanSingle from '../components/modals/CreateLoanSingle';

class LoanRequests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loans: [],
      loan_arr: [],
      selected_loans: {},
      query: '',
      current_page: new URLSearchParams(props.location.search).get('page') || 1,
      limit: 10,
      create: false,
      edit: false,
      cancel: false,
      single: false,
      multiple: false,
    };
  }

  handlePageChange = (data) => {
    const { limit, query } = this.state;
    fetchLoanRequests(data.currentPage, query, 'created_on', 'DESC', limit)
      .then(({ data: { requests: loans } }) => this.setState({
        loans,
      }));
  };

  onSearch = (e) => {
    const { limit } = this.state;
    this.setState({ query: e.currentTarget.value });
    fetchLoanRequests(e.currentPage, e.currentTarget.value, 'created_on', 'DESC', limit)
      .then(({ data: { requests: loans } }) => this.setState({
        loans,
      }));
  }

  render() {
    const {
      loans, selected_loans, loan_arr, action,
      loading, loan, total, current_page, limit,
      create, edit, cancel, single, multiple,
    } = this.state;
    const { history } = this.props;
    return (
      <>
        <SideNav page="loan-requests" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="loan-requests" />
            <div className="row">
              <div className="col">
                <div className="filled--state loans" hidden={!loans.length}>
                  <div className="filter-and-search">
                    <div className="filter-and-search d-flex justify-content-end">
                      {Object.keys(selected_loans).length !== 0 && (
                      <div className="button-box me-lg-3">
                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={!!loading}
                          onClick={() => {
                            this.setState({ loading: 'Processing' }, async () => {
                              this.setState({
                                loan_arr: Object.keys(Object.fromEntries(
                                  Object.entries(selected_loans).filter(([key, value]) => value === true)) )
                              });
                              this.setState({ action: 'accept' });
                            });
                          }}>
                          {loading || 'Accept Loans'}
                        </button>
                      </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="card default-card page-table">
                        <div className="empty-state no-result" hidden>
                          <img src={undrawSearch} alt="Illustration for search" />
                          <h3 className="empty-state__title">
                            No results found.
                          </h3>
                          <p className="empty-state__subtext">
                            Please check your spelling or try searching for something different.
                          </p>
                        </div>

                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th className="select_loan">
                                  <input
                                    type="checkbox"
                                    className="check-ticker-input"
                                    onChange={(e) => this.setState({
                                      selected_loans: loans.reduce((acc, cat) => {
                                        if (e.target.checked && !document.getElementById(`loan_id${cat.id}`)?.disabled) acc[cat.id] = e.target.checked;
                                        else delete acc[cat.id];
                                        return acc;
                                      }, {}),
                                    })} />
                                </th>
                                <th className="name">Name</th>
                                <th className="loan_amount">Loan Amount</th>
                                <th className="status">Score</th>
                                <th className="paid_loans">Paid Loans</th>
                                <th className="penalty_loans">Penalty Loans</th>
                                <th className="loan_type">Loan Type</th>
                                <th className="date-time">Date</th>
                                <th className="more-action"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {loans.map((loan) => (
                                <tr key={loan.id} role="button" onClick={() => history.push(`loans/${loan.id}`)}>
                                  <td className="select_loan text-nowrap" onClick={(e) => e.stopPropagation()}>
                                    <input
                                    id={`loan_id${loan.id}`}
                                      type="checkbox"
                                      className="check-ticker-input"
                                      checked={!!selected_loans[loan.id]}
                                      disabled={loan?.status_id !== 7 && loan?.status_id !== 10}
                                      onChange={() => this.setState({
                                        selected_loans: {
                                          ...selected_loans, [loan.id]: !selected_loans[loan.id],
                                        },
                                      })} />
                                  </td>
                                  <td className="name text-nowrap">
                                    {loan?.first_name}
                                    {' '}
                                    {loan?.last_name}
                                  </td>
                                  <td className="loan_amount text-nowrap">{Number(loan.loan_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                  <td className="score text-nowrap">{loan?.score}</td>
                                  <td className="paid_loans text-nowrap">{loan?.paid_loans}</td>
                                  <td className="penalty_loans text-nowrap">{loan?.penalty_loans}</td>
                                  <td className="loan_type text-nowrap">{loan?.merchant_purchase ? "BNPL" : "General"}</td>
                                  <td className="date-time text-nowrap">
                                    <span className="date">{moment(loan.created_on).format('MMM DD, YYYY, h:mm:ss a')}</span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <Pagination
                        totalRecords={total}
                        pageLimit={limit}
                        pageNeighbours={1}
                        onPageChanged={this.handlePageChange}
                        initialPage={current_page} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <LoanDetails
          visible={!!loan}
          data={loan}
          onClose={() => this.setState({ loan: null })} />
        <EditLoan
          visible={!!edit}
          data={edit}
          onSubmit={() => this.handlePageChange({})}
          onClose={() => this.setState({ edit: null })} />
        <CancelLoan
          visible={cancel}
          data={cancel}
          onClose={() => this.setState({ cancel: null })} />
        <CreateLoan
          visible={create}
          history={this.props.history}
          onSubmit={({ option }) => {
            this.setState({ create: false, [option]: true });
          }}
          onClose={() => this.setState({ create: false })} />
        <CreateLoanSingle
          visible={single}
          onSubmit={() => this.handlePageChange({})}
          onClose={() => this.setState({ single: false })} />
        <CreateLoanMultiple
          visible={multiple}
          onSubmit={() => this.handlePageChange({})}
          onClose={() => this.setState({ multiple: false })} />
        <AcceptLoan
          visible={action === 'accept'}
          data={loan_arr.map(id => ({ id }))}
          onClose={() => this.setState({ action: null })} />
      </>
    );
  }
}

export default LoanRequests;
